import React from "react";
import { Link } from "react-router-dom";
import { RiArrowRightLine } from "react-icons/ri";
import {
  getAchievementImage,
  getAchievementPath,
} from "../cms/achievements";
import { useCmsAchievements } from "../cms/useCmsContent";

export default function Achievements({ content = {} }) {
  const { achievements } = useCmsAchievements();
  const visibleAchievements = achievements.slice(0, 3);

  return (
    <section className="achievements-band">
      <div className="container">
        <div className="achievements-header">
          <div>
            <p className="section-kicker mb-3">
              {content.kicker || "Réalisations"}
            </p>
            <h2 className="section-heading mb-0">
              {content.title || "Des missions concrètes menées avec méthode."}
            </h2>
          </div>
          <p>
            {content.description ||
              "Quelques exemples de projets structurés pour renforcer les équipes, cadrer les priorités et produire des résultats vérifiables."}
          </p>
        </div>

        <div className="achievements-grid">
          {visibleAchievements.map((achievement) => (
            <article className="achievement-card" key={achievement._id || achievement.title}>
              <div className="achievement-card-media">
                <img src={getAchievementImage(achievement)} alt={achievement.title} />
                <span>{achievement.category || "Mission"}</span>
              </div>
              <div className="achievement-card-body">
                <div
                  className="achievement-meta"
                  title={[achievement.country, achievement.year, achievement.clientName].filter(Boolean).join(" · ")}
                >
                  {[achievement.country, achievement.year, achievement.clientName]
                    .filter(Boolean)
                    .join(" · ")}
                </div>
                <h3>
                  <Link to={getAchievementPath(achievement)}>{achievement.title}</Link>
                </h3>
                <p>{achievement.description}</p>
                {achievement.metrics?.length > 0 && (
                  <div className="achievement-metrics">
                    {achievement.metrics.slice(0, 2).map((metric) => (
                      <div key={`${achievement.title}-${metric.value}-${metric.label}`}>
                        <strong>{metric.value}</strong>
                        <span>{metric.label}</span>
                      </div>
                    ))}
                  </div>
                )}
                {achievement.result && (
                  <div className="achievement-result">{achievement.result}</div>
                )}
                <Link className="achievement-link" to={getAchievementPath(achievement)}>
                  Voir le détail <span aria-hidden="true">&rarr;</span>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="achievements-footer">
          <Link to="/realisations" className="btn btn-outline-dark">
            Voir toutes les missions
          </Link>
          <Link to="/contact" className="btn btn-success">
            {content.cta || "Parler d'un projet similaire"}
            <RiArrowRightLine aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
